/** Legacy device notifications store router paths, not server endpoints.
 * Use a hash link so existing notifications work in hosted and packaged admins.
 */
export function notificationLink(link: string): string {
  return /^\/devices(?:[/?#]|$)/.test(link) ? `#${link}` : link;
}

/** 알림 링크로 이동한다. 이미 그 주소에 있으면 브라우저가 hashchange를 내지 않아
 * 화면이 링크를 다시 읽지 못한다 — 그때는 직접 알린다(SCDS-76). */
export function openNotificationLink(link: string): void {
  const href = notificationLink(link);
  if (new URL(href, window.location.href).href === window.location.href) {
    window.dispatchEvent(new HashChangeEvent('hashchange'));
    return;
  }
  window.location.assign(href);
}
